import { APP_INIT, APP_SHOW_ALERT, APP_HIDE_ALERT, APP_SET_SESSION_ID,SET_SEARCHING ,SET_SEARCH_TEXT_CLEAR} from './types'

const initialState = {
	ready: false,
	isShowAlert: false,
	alertMessage: '',
	alertType: null,
	closeTimeout: null,
	session_id: null,
	searching: null,
	searchText:'',
}

export const state = { ...initialState }

export default {
	[SET_SEARCH_TEXT_CLEAR]: (state) => {
		state.searchText = ''
	},
	[APP_INIT]: (state) => {
		state.ready = true
	},
	[APP_SHOW_ALERT]: (state, payload) => {
		const {message, closeTimeout, type} = payload

		state.isShowAlert = true
		state.alertMessage = message
		state.alertType = type
		state.closeTimeout = closeTimeout
	},
	[APP_HIDE_ALERT]: (state, payload) => {
		state.isShowAlert = false
		state.alertMessage = payload
		state.closeTimeout = null
	},
	[APP_SET_SESSION_ID]: (state, id) => {
		state.session_id = id
	},
	[SET_SEARCHING](state, payload) {
		state.searching = payload
	},
}
